import { HotelModel } from 'api-hooks/hotel';
import { generateId } from 'common/utils/string';
import React from 'react';

import { HotelFormType, HotelRoomFormType } from '../components/form-type';

export function onAddNewHotelRoom(): HotelRoomFormType {
  return {
    id: undefined,
    customId: generateId(),
    description: '',
    size: '',
    type: '',
  };
}

export default function useGetDefaultValues(hotel?: HotelModel): HotelFormType {
  const defaultValues = React.useMemo<HotelFormType>(() => {
    const hotelRooms: HotelRoomFormType[] = hotel?.hotelRooms?.map((hr) => {
      return {
        customId: generateId(),
        description: hr.description || '',
        id: hr.id || '',
        size: hr.size || '',
        type: hr.type || '',
      };
    }) ?? [onAddNewHotelRoom()];

    return {
      address: hotel?.address || '',
      area: hotel?.area || '',
      checkIn: hotel?.checkIn || '',
      checkOut: hotel?.checkOut || '',
      cityCountry: hotel?.cityCountry || '',
      description: hotel?.description || '',
      email: hotel?.email || '',
      name: hotel?.name || '',
      phone: hotel?.phone || '',
      yearFounded: hotel?.yearFounded || '',
      preferences: (hotel?.preferences || []).map((preference) => {
        return preference;
      }),
      hotelRooms,
      regulation: hotel?.regulation || '',
      mandatoryFee: hotel?.mandatoryFee || '',
      data: hotel,
    };
  }, [hotel]);

  return defaultValues;
}
